<template src="./html/Schedules.html"></template>

<script>
	import ScheduleCreate from './../views/Create.vue'
	import ScheduleEdit from './../views/Edit.vue'

	export default {
		props: ['user', 'isAuth', 'item'],
		components: {
			'schedule-create': ScheduleCreate,
			'schedule-edit': ScheduleEdit,
		},
		data () {
			return {
			}
		},
		methods: {
			reload() {
				this.$emit('reload')
			},
			//-- SCHEDULES

			//-- Funcion para abrir el modal del component de schedule-create y pasarle el task
			openCreateSchedule() {
				this.$refs.schedulecreate.open()
				this.$refs.schedulecreate.item = this.item
			},
		},
	}
</script>


// WEBPACK FOOTER //
// src/components/projects/schedules/layout/Schedules.vue